<script setup lang="ts">
import { AlertCircle } from 'lucide-vue-next'
import { computed, HTMLAttributes, unref } from 'vue'
import { cn } from '../../lib/utils'
import { DataStateLoose } from '../../types/types'
import { Alert, AlertDescription, AlertTitle } from '../ui/alert'

const props = defineProps<{
  class?: HTMLAttributes['class']
  error?: DataStateLoose['error']
  isAction?: boolean
  isError?: DataStateLoose['isError']
}>()

// Modellvalideringen i ASP.NET (400 «One or more validation errors occurred») har ingen
// detail, bare feltfeil i errors. Vis dem, ellers står brukeren igjen med «unknown error».
const validationMessages = computed(() =>
  Object.values(unref(props.error)?.validationErrors ?? {}).flat()
)
</script>
<template>
  <Alert variant="destructive" :class="cn('flex gap-4 w-fit', props.class)">
    <div class="flex gap-1 flex-col">
      <div class="flex gap-2">
        <AlertCircle class="w-4 h-4 shrink-0" />
        <AlertTitle>{{ unref(error).error }}</AlertTitle>
      </div>
      <AlertDescription v-if="!unref(error).isUnauthorized && validationMessages.length">
        <ul class="list-disc pl-4">
          <li v-for="message in validationMessages" :key="message">{{ message }}</li>
        </ul>
      </AlertDescription>
      <AlertDescription v-else>
        {{
          unref(error).isUnauthorized
            ? isAction
              ? "You don't have the required permissions to perform this action."
              : "You don't have the required permissions to view this data."
            : unref(error)?.problemDetails?.detail ||
              'An unknown error occurred. Please try again later.'
        }}
      </AlertDescription>
    </div>
    <slot />
  </Alert>
</template>
